var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"/DMS3/Nv/VozyNaCeste/List/"}})}
var staticRenderFns = []

export { render, staticRenderFns }